import { IMessage } from "@/lib/types";
import { AssistantAvatar } from "@/components/ui/assistantavatar";
import Markdown from "react-markdown";
import { ArrowsCounterClockwise, Check, ClipboardText } from "@phosphor-icons/react";
import React from "react";

interface AsssitantMessageProps {
    message: IMessage;
    tryAgain: () => void;
}

export const AssistantMessage = ({ tryAgain, message }: AsssitantMessageProps) => {
    const [copied, setCopied] = React.useState(false);
    const copyToClipboard = async (text: string) => {
        navigator.clipboard.writeText(text).then(() => {
            setCopied(true);
            setTimeout(() => {
                setCopied(false);
            }, 3000);
        });
    };
    return (
        <>
            <div className="flex flex-row items-start">
                <div className={"hidden lg:block lg:mr-[14px] lg:mt-2"}>
                    <AssistantAvatar size={24} animate={false} />
                </div>
                <div className="flex flex-col items-start">
                    {message.content.map((content, idx) => (
                        <div key={`content-${idx}`} className={"flex-auto"}>
                            {content.text && (
                                <div
                                    className={
                                        "bg-zinc-200 rounded-xl rounded-bl-none lg:rounded-bl-xl py-1.5 px-4 mb-4 prose prose-zinc text-md max-w-[calc(100vw-1rem)] lg:max-w-[65ch]"
                                    }
                                >
                                    <Markdown>{content.text}</Markdown>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
                <div className={"hidden lg:block lg:ml-[14px] lg:w-[24px] lg:h-1 lg:flex-none"}>
                    &nbsp;
                </div>
            </div>
            <div
                className={
                    "flex flex-row items-center lg:ml-[38px] text-sm text-zinc-900/50 -translate-y-3"
                }
            >
                <div
                    className={
                        "cursor-pointer group flex flex-row items-center mr-4 hover:text-zinc-900/75"
                    }
                    onClick={tryAgain}
                >
                    <div className={"mr-1 mt-0.5"}>
                        <ArrowsCounterClockwise size={16} />
                    </div>
                    <div className={"group-hover:underline"}>Try again</div>
                </div>
                {!copied && (
                    <div
                        className={
                            "cursor-pointer group flex flex-row items-center hover:text-zinc-900/75"
                        }
                        onClick={() =>
                            copyToClipboard(
                                message.content.map((content) => content.text).join("\n")
                            )
                        }
                    >
                        <div className={"mr-1 mt-0.5"}>
                            <ClipboardText size={16} />
                        </div>
                        <div className={"group-hover:underline"}>Copy response</div>
                    </div>
                )}
                {copied && (
                    <div
                        className={
                            "flex flex-row items-center cursor-pointer hover:text-zinc-900/75"
                        }
                    >
                        <div className={"mr-1 mt-0.5"}>
                            <Check size={16} />
                        </div>
                        <div>Copied</div>
                    </div>
                )}
            </div>
        </>
    );
};
